<div class="navbar-top">
  <div class="logo" [routerLink]="['/']">
    <img class="logo-icon" src="assets/images/logos/andi_logo_a.png" />
    <span class="logo-text">BRAIN</span>
  </div>

  <div class="buttons">
    <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
      <mat-icon class="secondary-text">menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
      <mat-icon class="secondary-text">arrow_back</mat-icon>
    </button>
  </div>
</div>

<div class="navbar-scroll-container" fusePerfectScrollbar [fusePerfectScrollbarOptions]="{ suppressScrollX: true }">
  <div class="navbar-content">
    <fuse-navigation [ngClass]="fuseConfig.layout.navbar.background" layout="vertical"></fuse-navigation>
  </div>
</div>
